import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.72 3.576C6.846 3.213 8.36 3 10 3c1.64 0 3.153.213 4.28.576.56.18 1.064.41 1.442.699.368.28.728.705.728 1.278v8.894c0 .573-.36.998-.728 1.278-.378.289-.882.518-1.441.699-1.128.363-2.64.576-4.281.576-1.64 0-3.153-.213-4.28-.576-.56-.18-1.064-.41-1.442-.699-.368-.28-.728-.705-.728-1.278V5.553c0-.573.36-.998.728-1.278.378-.289.882-.518 1.442-.699ZM4.95 5.57c.01-.02.046-.082.176-.18.204-.156.542-.325 1.023-.48C7.103 4.6 8.465 4.4 10 4.4c1.536 0 2.897.201 3.851.509.481.155.82.324 1.023.48.13.098.167.16.176.18v8.862c-.009.02-.046.082-.176.18-.203.155-.542.325-1.023.48-.954.308-2.316.509-3.851.509-1.535 0-2.897-.201-3.851-.509-.481-.155-.82-.324-1.023-.48-.13-.098-.167-.16-.176-.18V5.569Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.95 5.536a.7.7 0 0 0-1.4.017c0 .573.36.998.728 1.278.378.289.882.518 1.442.699 1.127.363 2.64.576 4.28.576 1.64 0 3.153-.213 4.28-.576.56-.18 1.064-.41 1.442-.699.368-.28.728-.705.728-1.278a.7.7 0 0 0-1.4-.017c-.009.02-.045.082-.176.181-.203.155-.542.325-1.023.48-.954.307-2.316.509-3.851.509-1.535 0-2.897-.202-3.851-.509-.481-.155-.82-.325-1.023-.48-.13-.1-.167-.161-.176-.18ZM4.95 11.466a.7.7 0 0 0-1.4.016c0 .573.36.998.728 1.279.378.288.882.518 1.442.698 1.127.363 2.64.576 4.28.576 1.64 0 3.153-.213 4.28-.576.56-.18 1.064-.41 1.442-.698.368-.28.728-.706.728-1.279a.7.7 0 0 0-1.4-.016c-.009.02-.045.081-.176.18-.203.156-.542.325-1.023.48-.954.308-2.316.51-3.851.51-1.535 0-2.897-.202-3.851-.51-.481-.155-.82-.324-1.023-.48-.13-.099-.167-.16-.176-.18Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.95 8.501a.7.7 0 0 0-1.4.017c0 .572.36.998.728 1.278.378.288.882.518 1.442.698 1.127.363 2.64.577 4.28.577 1.64 0 3.153-.214 4.28-.577.56-.18 1.064-.41 1.442-.698.368-.28.728-.706.728-1.278a.7.7 0 0 0-1.4-.017c-.009.02-.045.081-.176.181-.203.155-.542.325-1.023.48-.954.307-2.316.509-3.851.509-1.535 0-2.897-.202-3.851-.51-.481-.154-.82-.324-1.023-.479-.13-.1-.167-.162-.176-.18Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
